import type { Namespace } from "@/i18n/types";
import nsAccountMenuEN from "./en";
import nsAccountMenuJA from "./ja";

export const nsAccountMenu = {
  name: "accountMenu",
  locales: {
    ja: nsAccountMenuJA,
    en: nsAccountMenuEN,
  },
} satisfies Namespace<"accountMenu", typeof nsAccountMenuJA>;
